import { render, staticRenderFns } from "./about-news-img.vue?vue&type=template&id=585d5713&scoped=true&"
import script from "./about-news-img.vue?vue&type=script&lang=js&"
export * from "./about-news-img.vue?vue&type=script&lang=js&"
import style0 from "./about-news-img.vue?vue&type=style&index=0&id=585d5713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d5713",
  null
  
)

export default component.exports